﻿var jquery = require('jquery');
require('jquery.mapster');
var HabEvents = require('../../Global/habitaclia-events');
var Functions = require('./functions');
var AccountUser = require('./account-user');
var storageService = require("../../Global/storage-service").default;

(function () {
    'use strict';

    var Header = function (headerDTO) {
        this.__headerDTO = headerDTO;
        this.__$mapAjaxContainer = jquery('#js-map-container-ajax');
        this.__$mapImgAjax = jquery('#js-map-img-ajax');
        this.__$mapSub = jquery('#js-map-sup');
        this.__$mapInf = jquery('#js-map-inf');
        this.__$mapCoordsAjax = jquery('#js-map-coords-ajax');
        this.__$cerrarMapa = jquery('#js-cerrar-mapa');
        this.__$headGeo = jquery('#js-head-geo');
        this.__$navElement = jquery('nav');
        this.storageService = new storageService();
        
       
        this.__$selectIdiomas = jquery('#idSelectIdioma');
        this.eventClickToAttach = (this.__headerDTO.device === "mobile" || this.__headerDTO.device === "tablet" ? "click touchstart" : "click");
        this.__misBusquedasLoaded = false;
        this.__misNotificacionesLoaded = false;
    };

    var __registerEvents = function () {
        var self = this;

        __registerEventsMenuUsuario.call(self);

        this.__$headGeo.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (self.__$mapAjaxContainer.hasClass('hide')) {
                jquery.publish(HabEvents.EventsEnum.CerrarMenu);
                __cerrarDropDowns.call(self);

                if (self.__$mapAjaxContainer.hasClass('no-map')) {
                    __getMap.call(self, jquery(this));
                    self.__$mapAjaxContainer.removeClass('no-map');
                }
                self.__$mapAjaxContainer.addClass('show');
                self.__$mapAjaxContainer.removeClass('hide');
            } else {
                jquery.publish(HabEvents.EventsEnum.CerrarMenu);
            }
        });

        this.__$cerrarMapa.on((this.__headerDTO.device === 'mobile' || this.__headerDTO.device === 'tablet' ? 'click touchend' : 'click'), function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.__$mapAjaxContainer.addClass('hide');
            self.__$mapAjaxContainer.removeClass('show');
            jquery.publish(HabEvents.EventsEnum.CerrarMenu);
        });

        this.__$mapSub.on((this.__headerDTO.device === 'mobile' || this.__headerDTO.device === 'tablet' ? 'click touchend' : 'click'), function (e) {
            e.preventDefault();
            __getMap.call(self, jquery(this));
            e.stopPropagation();
        });

        this.__$mapInf.on((this.__headerDTO.device === 'mobile' || this.__headerDTO.device === 'tablet' ? 'click touchend' : 'click'), function () {
            document.location = this.href;
        });

        this.__$mapCoordsAjax.on('click', 'area', function (e) {
            e.stopPropagation();
            var jqThis = jquery(this);
            
            if (jqThis.attr('mapa') === '-1') {
                e.preventDefault();
                __getMap.call(self, jqThis);
            } else {
                if (jqThis.attr('href') !== '#') {
                    location.href = jqThis.attr('href');
                } else {
                    e.preventDefault();
                }
            }
        });


        jquery.subscribe(HabEvents.EventsEnum.LoginAjaxOk, function () {
            __recargarMenuUsuario.call(self);
            self.__headerDTO.isUserLogged = "True";
        });

    };

    var __registerEventsMenuUsuario = function () {

        var self = this;

        this.__$dropDownItemsAnchor = jquery('.js-lnk-dropdown-item');
        this.__$headerBusquedas = jquery('#js-header-busquedas');
        this.__$headerNotificaciones = jquery('#js-header-notificaciones');
        this.__$headerFavoritos = jquery('#js-head-fav');
        this.__$headerInteracted = jquery('#js-head-interacted');
        this.__$previewBusquedas = jquery('#js-preview-busquedas');
        this.__$previewNotificaciones = jquery('#js-preview-notificaciones');
        this.__$cajonListaPreviewBusquedas = jquery('.cajon_lista_preview_busqueda');
        this.__$dropDownsHab = jquery('.dropdown');
        this.__$dropDownItems = jquery('.dropdown-container');
        this.__$dropDownSubmenuHab = jquery('.dropdown-submenu');
        this.__$calcHipoteca = jquery('.js-nav-calc-hipoteca');
        this.__$logOutBtn = jquery('.salir-menu');

        
        this.__$logOutBtn.on('click touchstart', function (e) {
            e.preventDefault();
            jquery.publish(HabEvents.EventsEnum.LogOut, [e.target]);
            self.storageService.checkLocalStorage() && self.storageService.removeItem('keepForm');
        });
        

        this.__$calcHipoteca.on('click touchstart', function () {
            jquery.publish(HabEvents.EventsEnum.ClickCalcHipoteca, ['menu']);
        });

        this.__$headerBusquedas.on("click touchstart", function () {

            if (self.__headerDTO.isUserLogged === 'False') {
                AccountUser.ShowModalLogin("busquedas", this.getAttribute("data-next-url"));
            } else {
                jquery.publish(HabEvents.EventsEnum.ClickHeader, ['ficha-nav-button', 'mis-busquedas-cabecera']);
                self.__$previewBusquedas.toggleClass('hide-none');
                if (!self.__misBusquedasLoaded) {
                    __getPreviewMisBusquedas.call(self);
                }
            }
        });

        this.__$headerNotificaciones.on("click touchstart", function () {

            if (self.__headerDTO.isUserLogged === 'False') {
                AccountUser.ShowModalLogin("notificaciones", this.getAttribute("data-next-url"));
            } else {
                jquery.publish(HabEvents.EventsEnum.ClickHeader, ['ficha-nav-button', 'mis-busquedas-cabecera']);
                self.__$previewNotificaciones.toggleClass('hide-none');
                if (!self.__misNotificacionesLoaded) {
                    __getPreviewMisNotificaciones.call(self);
                }
            }

        });

        this.__$headerFavoritos.on("click touchstart", function () {

            if (self.__headerDTO.isUserLogged === 'False') {
                AccountUser.ShowModalLogin("favoritos", this.getAttribute("data-next-url"));
            }

        });

        this.__$headerInteracted.on("click touchstart", function () {

            if (self.__headerDTO.isUserLogged === 'False') {
                AccountUser.ShowModalLogin("interacted", this.getAttribute("data-next-url"));
            }

        });

        this.__$cajonListaPreviewBusquedas.click(function (e) {
            e.stopPropagation();
        });


        this.__$dropDownItemsAnchor.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            document.location = this.href;
        });

        this.__$dropDownsHab.on(this.eventClickToAttach, function (e) {
            __bindDropDownHabEvent.call(self, this, e);
        });

        this.__$dropDownSubmenuHab.on(this.eventClickToAttach, function (e) {
            __bindDropDownSubMenuEvent.call(self, this, e);
        });
    };

    var __getPreviewMisBusquedas = function () {
        var self = this;
        var request = jquery.get(this.__headerDTO.UrlAjaxBusquedas);

        request.done(
            function (data) {
                var oData = JSON.parse(data);
                if (oData[0].status.code === 200) {
                    var sHtmlResponse = oData[1].html;
                    var $CajaBusquedas = jquery('#js-header-busquedas .cajon_lista_preview_busqueda');
                    if (sHtmlResponse.length > 0) {
                        $CajaBusquedas.html(Functions.NormalizeHTML(sHtmlResponse));
                    }
                    self.__misBusquedasLoaded = true;
                }
            }
        );

        request.fail(function (jqXHR, textStatus, errorThrown) {
            var msg = 'Error getPreviewMisBusquedas, textStatus: ' + textStatus + ' errorThrown: ' + errorThrown;
            throw msg;
        });
    };



    var __getPreviewMisNotificaciones = function () {
        var self = this;
        var request = jquery.get(this.__headerDTO.UrlAjaxNotificaciones);

        request.done(
            function (data) {
                var oData = JSON.parse(data);
                if (oData[0].status.code === 200) {
                    var sHtmlResponse = oData[1].html;
                    var $CajaBusquedas = jquery('#js-header-notificaciones .cajon_lista_preview_busqueda');
                    if (sHtmlResponse.length > 0) {
                        $CajaBusquedas.html(Functions.NormalizeHTML(sHtmlResponse));
                    }
                    self.__misNotificacionesLoaded = true;
                }
            }
        );

        request.fail(function (jqXHR, textStatus, errorThrown) {
            var msg = 'Error __getPreviewMisNotificaciones, textStatus: ' + textStatus + ' errorThrown: ' + errorThrown;
            throw msg;
        });


    };

    var __getMap = function (jqElement) {

        var self = this;

        var oData = {
            action: 'getMap',
            idioma: this.__headerDTO.idioma,
            codPais: this.__headerDTO.codPais,
            codProv: jqElement.attr('codProv'),
            codCom: jqElement.attr('codCom'),
            codArea: jqElement.attr('codArea'),
            codPob: jqElement.attr('codPob'),
            codDist: jqElement.attr('codDist'),
            tipReg: this.__headerDTO.tipReg,
            tipOp: this.__headerDTO.tipOp,
            tipInm: this.__headerDTO.tipInm,
            tipInm2: this.__headerDTO.tipInm2
        };

        if (!jqElement.is('area')) {
            oData = __getDataForNoArea.call(this, oData, jqElement);
        }

        var request = jQuery.ajax({
            url: this.__headerDTO.urlGetMapsHabitacliaASP,
            type: 'POST',
            dataType: 'json',
            data: oData,
            statusCode: {
                404: function () {
                    alert('page not found');
                }
            }
        });

        request.done(function (data) {
            if (data.status.code === 1) {
                var sAreas = '';
                var results = data.results;
                var sParams = '';

                self.__$mapImgAjax.attr('src', results.imgMapa + '?v=' + self.__headerDTO.versionArchivos);
                self.__$mapSub.attr('codProv', results.geo.codProv).attr('codCom', results.geo.codCom).attr('codArea', results.geo.codArea).attr('codPob', results.geo.codPob).attr('alt', results.anchorSup).removeClass('invisible').addClass('visible').html('<span></span>' + results.anchorSup);
                self.__$mapInf.attr('href', (results.linkInf) === '#' ? '#' : Functions.GenerarPathJS('HAB_INMUEBLES', (results.tipReg === 'I') ? 'listainmuebles.htm' : 'listapromocioneshabitaclia.htm', results.linkInf, self.__headerDTO.urlHabitaclia) + sParams).text(results.anchorInf).attr('alt', results.anchorInf).removeClass('invisible').addClass('visible');

                if (results.model === 'provincia') {
                    self.__$mapSub.removeClass('visible').addClass('invisible');
                    self.__$mapInf.removeClass('visible').addClass('invisible');
                }

                if (results.model === 'barcelona') {
                    self.__$mapInf.attr('href', Functions.GenerarPathJS('HAB_INMUEBLES', (results.tipReg === 'I') ? 'listainmuebles.htm' : 'listapromocioneshabitaclia.htm', results.linkInf, self.__headerDTO.urlHabitaclia) + sParams);
                }

                if (results.model === 'distrito') {
                    self.__$mapInf.attr('href', Functions.GenerarPathJS('HAB_INMUEBLES', (results.tipReg === 'I') ? 'listainmuebles.htm' : 'listapromocioneshabitaclia.htm', results.linkInf, self.__headerDTO.urlHabitaclia) + sParams);
                }

                for (var i = 0, length = results.mapas.length; i < length; i++) {
                    if (results.mapas[i].href.indexOf('z=') > 0) {
                        sParams = sParams.split('?st=').join('&st=');
                    }
                    else {
                        sParams = sParams.split('&st=').join('?st=');
                    }
                    sAreas += '<area shape="poly" title="' + results.mapas[i].title + '" coords="' + results.mapas[i].coords + '" href="' + Functions.GenerarPathJS("HAB_INMUEBLES", (results.tipReg === "I") ? "listainmuebles.htm" : "listapromocioneshabitaclia.htm", results.mapas[i].href, self.__headerDTO.urlHabitaclia) + sParams + '" mapa="' + results.mapas[i].mapa + '" codProv="' + results.mapas[i].codProv + '" codCom="' + results.mapas[i].codCom + '" codArea="' + results.mapas[i].codArea + '" codPob="' + results.mapas[i].codPob + '" codDist="' + results.mapas[i].codDist + '" codZona="' + results.mapas[i].codZona + '" data-group="' + results.mapas[i].dataGroup + '" />';
                }


                for (var j = 0, length2 = results.adyacentes.length; j < length2; j++) {
                    sAreas += '<area shape="poly" title="' + results.adyacentes[j].title + '" coords="' + results.adyacentes[j].coords + '" href="' + Functions.GenerarPathJS("HAB_INMUEBLES", (results.tipReg === "I") ? "listainmuebles.htm" : "listapromocioneshabitaclia.htm", results.adyacentes[j].href, self.__headerDTO.urlHabitaclia) + sParams + '" mapa="' + results.adyacentes[j].mapa + '" codProv="' + results.adyacentes[j].codProv + '" codCom="' + results.adyacentes[j].codCom + '" codArea="' + results.adyacentes[j].codArea + '" codPob="' + results.adyacentes[j].codPob + '" codDist="' + results.adyacentes[j].codDist + '" codZona="' + results.adyacentes[j].codZona + '" data-group="' + results.adyacentes[j].dataGroup + '"  />';
                }
                

                self.__$mapCoordsAjax.empty().attr('model', results.model).html(sAreas);
            }

           

            if (typeof (jquery().tooltipster) !== 'undefined' && self.__headerDTO.device === 'desktop') {
                jquery('#js-map-coords-ajax > area').tooltipster({ contentCloning: true });
            }

            if (navigator.userAgent.indexOf('Trident') < 1) {
                if (typeof (jquery().mapster) !== 'undefined') {
                    self.__$mapImgAjax.mapster({ isSelectable: false, fillColor: 'ff9900', fillOpacity: 0.4, clickNavigate: false, mapKey: 'data-group', noHrefIsMask: false });
                }
            }
        });
    };


    var __getDataForNoArea = function (oData, jqElement) {
        oData = {
            action: 'getMap',
            idioma: this.__headerDTO.idioma,
            codPais: this.__headerDTO.codPais,
            codProv: (jqElement.attr('codProv') || this.__headerDTO.codProv),
            tipReg: this.__headerDTO.tipReg,
            tipOp: this.__headerDTO.tipOp,
            tipInm: this.__headerDTO.tipInm,
            tipInm2: this.__headerDTO.tipInm2
        };

        var bLoad = this.__$mapAjaxContainer.hasClass('no-map');

        switch (this.__$mapCoordsAjax.attr('model')) {
            case 'comarca':
                if (bLoad) {
                    oData.codCom = this.__headerDTO.codCom;
                }
                break;
            case 'area':
                oData.codCom = (!bLoad ? jqElement.attr('codCom') : this.__headerDTO.codCom);
                oData.codArea = (!bLoad ? jqElement.attr('codArea') : this.__headerDTO.codArea);
                break;
            case 'poblacion':
                oData.codCom = (!bLoad ? jqElement.attr('codCom') : this.__headerDTO.codCom);
                if (bLoad) {
                    oData.codArea = (!bLoad ? jqElement.attr('codArea') : this.__headerDTO.codArea);
                    oData.codPob = (!bLoad ? jqElement.attr('codPob') : this.__headerDTO.codPob);
                }
                break;
            case 'barcelona':
                oData.codCom = (!bLoad ? jqElement.attr('codCom') : this.__headerDTO.codCom);
                if (bLoad) {
                    oData.codArea = (!bLoad ? jqElement.attr('codArea') : this.__headerDTO.codArea);
                    oData.codPob = this.__headerDTO.codPob;
                }
                break;
            case 'distrito':
                oData.codCom = (!bLoad ? jqElement.attr('codCom') : this.__headerDTO.codCom);
                oData.codArea = (!bLoad ? jqElement.attr('codArea') : this.__headerDTO.codArea);
                oData.codPob = (!bLoad ? jqElement.attr('codPob') : this.__headerDTO.codPob);
                if (bLoad) {
                    oData.codDist = this.__headerDTO.codDist;
                }
                break;
        }

        return oData;
    };


    var __bindDropDownHabEvent = function (that, e) {
        if (e.target.nodeName !== 'A' || jquery(that).hasClass('dropdown')) {
            e.preventDefault();
            e.stopPropagation();
            var $menu = jquery('#' + that.getAttribute('data-show'));
            if ($menu.hasClass('hide')) {
                jquery.publish(HabEvents.EventsEnum.CerrarMenu);
                __cerrarDropDowns.call(this);
                __cerrarMapa.call(this);
                jquery(that).addClass('active');
                $menu.removeClass('hide');
                $menu.addClass('show');
            } else {
                jquery('.dropdown').removeClass('active');
                $menu.addClass('hide');
                $menu.removeClass('show');
            }
        }
    };

    var __bindDropDownSubMenuEvent = function (that, e) {
        if (e.target.nodeName !== 'A' || jquery(that).hasClass('dropdown-submenu')) {
            e.preventDefault();
            e.stopPropagation();
            var $submenu = jquery('#' + that.getAttribute('data-sub'));
            var $itemMenu = jquery(that).closest('.dropdown-item');
            if ($submenu.hasClass('hide-none')) {
                $submenu.removeClass('hide-none');
                $itemMenu.addClass('open');
            } else {
                $submenu.addClass('hide-none');
                $itemMenu.removeClass('open');
            }
        }
    };

    var __cerrarDropDowns = function () {
        this.__$dropDownsHab.removeClass('active');
        this.__$dropDownItems.addClass('hide');
        this.__$dropDownItems.removeClass('show');
    };

    var __cerrarMapa = function () {
        this.__$mapAjaxContainer.addClass('hide');
        this.__$mapAjaxContainer.removeClass('show');
    };

    var __recargarMenuUsuario = function () {

        var self = this;

        var request = jquery.ajax({
            url: this.__headerDTO.urlRecargarMenuUsuario,
            type: 'POST'
        });

        request.done(function (result) {
            self.__$navElement.html(result);
            __registerEventsMenuUsuario.call(self);
        });
    };

    Header.prototype = {
        constructor: Header,
        registerEvents: __registerEvents,
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = Header;
    }
    else {
        window.Header = Header;
    }
})();